import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

export default function ScrollToTopButton() {
    const [isVisible, setIsVisible] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            const scrolled = window.pageYOffset;
            const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const progress = (scrolled / windowHeight) * 100;

            setScrollProgress(progress);
            setIsVisible(scrolled > 500);
        };

        // Detectar si hay un modal abierto observando el overflow del body
        const checkModalOpen = () => {
            setIsModalOpen(document.body.style.overflow === "hidden");
        };

        window.addEventListener("scroll", toggleVisibility);
        toggleVisibility();

        // Observer para detectar cambios en el body
        const observer = new MutationObserver(checkModalOpen);
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ["style"],
        });

        checkModalOpen();

        return () => {
            window.removeEventListener("scroll", toggleVisibility);
            observer.disconnect();
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    // No mostrar el botón si hay un modal abierto
    const shouldShow = isVisible && !isModalOpen;

    return (
        <AnimatePresence>
            {shouldShow && (
                <motion.button
                    initial={{ scale: 0, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0, opacity: 0 }}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    onClick={scrollToTop}
                    className="fixed bottom-8 right-8 z-40 p-4 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-950 group"
                    aria-label="Volver arriba"
                >
                    {/* Progress Circle */}
                    <svg className="absolute inset-0 w-full h-full -rotate-90">
                        <circle cx="50%" cy="50%" r="46%" fill="none" stroke="rgba(255, 255, 255, 0.2)" strokeWidth="2" />
                        <motion.circle
                            cx="50%"
                            cy="50%"
                            r="46%"
                            fill="none"
                            stroke="rgba(255, 255, 255, 0.8)"
                            strokeWidth="2"
                            strokeLinecap="round"
                            initial={{ pathLength: 0 }}
                            animate={{ pathLength: scrollProgress / 100 }}
                            transition={{ duration: 0.2, ease: "easeOut" }}
                            style={{
                                strokeDasharray: "0 1",
                            }}
                        />
                    </svg>

                    {/* Icon */}
                    <motion.div
                        animate={{ y: [0, -3, 0] }}
                        transition={{
                            duration: 1.5,
                            repeat: Infinity,
                            ease: "easeInOut",
                        }}
                    >
                        <FaArrowUp className="w-5 h-5 relative z-10" />
                    </motion.div>
                </motion.button>
            )}
        </AnimatePresence>
    );
}
